import ResourceList from "@/components/ResourceList";
import { CheckSquare } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Todos() {
  return (
    <ResourceList
      title="To-do"
      subtitle="Care tasks"
      resource="todos"
      icon={CheckSquare}
      testidPrefix="todos"
      emptyText="Nothing to do — take a breath."
      itemTitle={(t) => t.title}
      itemSubtitle={(t) => t.notes}
      itemBadge={(t) => t.done ? <span className="mt-2 inline-block text-xs bg-[#3E7B5C]/15 text-[#3E7B5C] rounded-full px-3 py-1">Done</span> : null}
      extraActions={(t, reload) => (
        <button
          data-testid={`todos-toggle-${t.id}`}
          onClick={async () => {
            await api.patch(`/todos/${t.id}`, { done: !t.done });
            toast.success(t.done ? "Marked as pending" : "Marked as done");
            reload();
          }}
          className="mt-3 w-full rounded-full text-sm px-4 py-1.5 border border-[#EBE8E0] hover:bg-[#EBE8E0]/60"
        >
          {t.done ? "Undo" : "Complete"}
        </button>
      )}
      fields={[
        { key: "title", label: "Task", required: true, placeholder: "Call Dr. Patel for follow-up" },
        { key: "priority", label: "Priority", options: [
          { value: "low", label: "Low" }, { value: "medium", label: "Medium" }, { value: "high", label: "High" },
        ] },
        { key: "due_at", label: "Due date", type: "date" },
        { key: "notes", label: "Notes", textarea: true },
      ]}
    />
  );
}
